import React from 'react';

export const ArrowDownIcon = props => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M12 16l5-6H7z' />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/icons/ArrowDownIcon.jsx